@if (hasNoTeeth$ | async) {
  <div class="layout-margin flex flex-col items-center justify-around">
    <h3>Chart is missing all teeth</h3>
    <button
      *ngIf="!disabled"
      mat-flat-button
      color="primary"
      (click)="openAddTooth()"
    >
      Add Tooth
    </button>
  </div>
} @else {
  @if (renderer$ | async; as renderer) {
    <pr-dental-chart-svg [renderer]="renderer" />
  } @else {
    <mat-progress-bar mode="indeterminate" />
  }
}
